import { compose } from 'recompose';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { GatewayDest } from 'react-gateway';

import * as reservationSelectors from '../reservation/selectors';
import * as shopSelectors from '../shops/selectors';
import config from '../../config';

const Header = ({ homeUrl, kiosk, location, shopLogo }) => {
  const linkTo = kiosk || location.query.showShops ? homeUrl : '';

  return (
    <header className="c-header-wrapper">
      <div className="o-wrapper o-wrapper--page">
        <div className="c-header">
          <h1 className="c-header__logo">
            <Link to={linkTo}>
              <img src={shopLogo} alt="" />
            </Link>
          </h1>
          <div className="c-header__title">
            <GatewayDest name="title" className="u-inline-block" />
          </div>
        </div>
      </div>
    </header>
  );
};
Header.propTypes = {
  homeUrl: PropTypes.string,
  kiosk: PropTypes.bool,
  location: PropTypes.shape({
    query: PropTypes.object,
  }).isRequired,
  shopLogo: PropTypes.string.isRequired,
};
Header.defaultProps = {
  homeUrl: '/',
  kiosk: false,
};

export default compose(
  withRouter,
  connect((state, ownProps) => {
    const shopId =
      shopSelectors.getShopId(state, ownProps.params.shopRoute) ||
      reservationSelectors.getShopId(state);
    const isLogoFetching = ownProps.params.shopRoute && !shopId && state.app.isFetching;
    return {
      shopLogo: isLogoFetching ? '' : (
        ownProps.logo ||
        shopSelectors.getShopLogo(state, shopId) ||
        reservationSelectors.getShopLogo(state)
      ) || config.fallbackShopLogo,
    };
  })
)(Header);



// WEBPACK FOOTER //
// ./src/app/components/Header.jsx